import { relations } from 'drizzle-orm'
import { date, integer, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
  getNullableIdReference,
} from '../common/utils'
import { properties } from './property'
import { packageVersionTasks } from './servicePackage'
import { users } from './user'

export const schedulingTypeEnum = pgEnum('scheduling_type', [
  'periodic',
  'annual',
  'seasonal_spring',
  'seasonal_fall',
  'seasonal_winter',
  'seasonal_summer',
])

export const maintenanceTasks = pgTable(
  'maintenance_tasks',
  {
    ...getBaseFields(),
    name: text().notNull(),
    description: text(),
    category: text(), // 'cleaning', 'inspection', 'maintenance', etc.
    schedulingType: schedulingTypeEnum(),
    defaultFrequencyDays: integer(),
    estimatedDurationMinutes: integer(),
    estimatedCost: getMonetaryField(), // For resident budget estimates
    price: getMonetaryField(), // Default billing price (can be adjusted per visit)
    deadline: date(),
    createdByUserId: getIdReference(() => users.id), // Required - tracks who created the task
    propertyId: getNullableIdReference(() => properties.id), // NULL = system task, NOT NULL = property-specific task
  },
  (table) => getBaseIndexes('maintenance_tasks', table),
)

export const maintenanceTaskSteps = pgTable(
  'maintenance_task_steps',
  {
    ...getBaseFields(),
    maintenanceTaskId: getIdReference(() => maintenanceTasks.id),
    stepNumber: integer().notNull(),
    name: text().notNull(),
    description: text(),
    instruction: text(),
  },
  (table) => getBaseIndexes('maintenance_task_steps', table),
)

export const maintenanceTasksRelations = relations(
  maintenanceTasks,
  ({ one, many }) => ({
    steps: many(maintenanceTaskSteps),
    packageVersionTasks: many(packageVersionTasks),
    createdByUser: one(users, {
      fields: [maintenanceTasks.createdByUserId],
      references: [users.id],
    }),
    property: one(properties, {
      fields: [maintenanceTasks.propertyId],
      references: [properties.id],
    }),
  }),
)

export const maintenanceTaskStepsRelations = relations(
  maintenanceTaskSteps,
  ({ one }) => ({
    maintenanceTask: one(maintenanceTasks, {
      fields: [maintenanceTaskSteps.maintenanceTaskId],
      references: [maintenanceTasks.id],
    }),
  }),
)
